import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Summer/Statistics/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Statistics',
  weeks: [10, 10],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Statistics/1InterpretCharts" */ './1InterpretCharts'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Statistics/2ComparisonSumAndDifference" */ './2ComparisonSumAndDifference'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Statistics/3InterpretLineGraphs" */ './3InterpretLineGraphs'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/Statistics/4DrawLineGraphs" */ './4DrawLineGraphs'
        )
    })
  ]
});
export default Block;
